// // Device fingerprinting service using FingerprintJS
// // This service handles device identification and storage

// class DeviceFingerprintService {
//   constructor() {
//     this.fingerprint = null;
//     this.isInitialized = false;
//   }

//   // Initialize FingerprintJS
//   async initialize() {
//     try {
//       // Dynamic import to avoid SSR issues
//       const { FingerprintJS } = await import('@fingerprintjs/fingerprintjs');

//       const fp = await FingerprintJS.load();
//       const result = await fp.get();

//       this.fingerprint = result;
//       this.isInitialized = true;

//       return this.fingerprint;
//     } catch (error) {
//       console.error('Failed to initialize device fingerprint:', error);
//       // Fallback: generate a simple fingerprint
//       this.fingerprint = this.generateFallbackFingerprint();
//       this.isInitialized = true;
//       return this.fingerprint;
//     }
//   }

//   // Generate fallback fingerprint if FingerprintJS fails
//   generateFallbackFingerprint() {
//     const canvas = document.createElement('canvas');
//     const ctx = canvas.getContext('2d');
//     ctx.textBaseline = 'top';
//     ctx.font = '14px Arial';
//     ctx.fillText('Device fingerprint fallback', 2, 2);

//     const fingerprint = [
//       navigator.userAgent,
//       navigator.language,
//       screen.width + 'x' + screen.height,
//       new Date().getTimezoneOffset(),
//       canvas.toDataURL(),
//       navigator.hardwareConcurrency || 'unknown',
//       navigator.deviceMemory || 'unknown',
//       navigator.platform,
//       window.devicePixelRatio || 'unknown',
//     ].join('|');

//     // Simple hash function
//     let hash = 0;
//     for (let i = 0; i < fingerprint.length; i++) {
//       const char = fingerprint.charCodeAt(i);
//       hash = (hash << 5) - hash + char;
//       hash = hash & hash; // Convert to 32-bit integer
//     }

//     return Math.abs(hash).toString(36);
//   }

//   // Get current device fingerprint
//   async getFingerprint() {
//     if (!this.isInitialized) {
//       await this.initialize();
//     }
//     return this.fingerprint;
//   }

//   // Store device fingerprint in localStorage
//   storeDeviceFingerprint(userId, fingerprint) {
//     try {
//       const deviceData = {
//         userId,
//         fingerprint,
//         timestamp: Date.now(),
//         userAgent: navigator.userAgent,
//         screenResolution: `${screen.width}x${screen.height}`,
//         timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
//       };

//       localStorage.setItem(
//         'govify_device_fingerprint',
//         JSON.stringify(deviceData),
//       );
//     } catch (error) {
//       console.error('Failed to store device fingerprint:', error);
//     }
//   }

//   // Get stored device fingerprint
//   getStoredDeviceFingerprint() {
//     try {
//       const stored = localStorage.getItem('govify_device_fingerprint');
//       return stored ? JSON.parse(stored) : null;
//     } catch (error) {
//       console.error('Failed to get stored device fingerprint:', error);
//       return null;
//     }
//   }

//   // Check if current device is recognized for a user
//   async isDeviceRecognized(userId) {
//     try {
//       const stored = this.getStoredDeviceFingerprint();
//       if (!stored || stored.userId !== userId) {
//         return false;
//       }

//       const currentFingerprint = await this.getFingerprint();
//       const isRecognized = stored.fingerprint === currentFingerprint;

//         stored: stored.fingerprint,
//         current: currentFingerprint,
//         isRecognized,
//       });

//       return isRecognized;
//     } catch (error) {
//       console.error('Failed to check device recognition:', error);
//       return false;
//     }
//   }

//   // Clear stored device fingerprint
//   clearStoredDeviceFingerprint() {
//     try {
//       localStorage.removeItem('govify_device_fingerprint');
//     } catch (error) {
//       console.error('Failed to clear device fingerprint:', error);
//     }
//   }

//   // Get device information for display
//   getDeviceInfo() {
//     const stored = this.getStoredDeviceFingerprint();
//     if (!stored) return null;

//     return {
//       userAgent: stored.userAgent,
//       screenResolution: stored.screenResolution,
//       timezone: stored.timezone,
//       lastUsed: new Date(stored.timestamp).toLocaleDateString(),
//     };
//   }
// }

// // Export singleton instance
// export const deviceFingerprintService = new DeviceFingerprintService();

const DEVICE_FINGERPRINT_STORAGE_KEY = 'govify_device_fingerprint:v1';
const LEGACY_DEVICE_FINGERPRINT_STORAGE_KEY = 'govify_device_fingerprint';

// Enhanced Device Fingerprint Service
class DeviceFingerprintService {
  constructor() {
    this.fingerprint = null;
    this.isInitialized = false;
  }

  // Initialize FingerprintJS
  async initialize() {
    try {
      const { default: FingerprintJS } = await import(
        '@fingerprintjs/fingerprintjs'
      );
      const fp = await FingerprintJS.load();
      const result = await fp.get();

      this.fingerprint = result.visitorId;
      this.isInitialized = true;

      return this.fingerprint;
    } catch (error) {
      console.error('Failed to initialize device fingerprint:', error);
      // Fallback: generate a simple fingerprint
      this.fingerprint = this.generateFallbackFingerprint();
      this.isInitialized = true;
      return this.fingerprint;
    }
  }

  // Generate fallback fingerprint if FingerprintJS fails
  generateFallbackFingerprint() {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    ctx.textBaseline = 'top';
    ctx.font = '14px Arial';
    ctx.fillText('Device fingerprint fallback', 2, 2);

    const fingerprint = [
      navigator.userAgent,
      navigator.language,
      screen.width + 'x' + screen.height,
      new Date().getTimezoneOffset(),
      canvas.toDataURL(),
      navigator.hardwareConcurrency || 'unknown',
      navigator.deviceMemory || 'unknown',
      navigator.platform,
      window.devicePixelRatio || 'unknown',
    ].join('|');

    // Simple hash function
    let hash = 0;
    for (let i = 0; i < fingerprint.length; i++) {
      const char = fingerprint.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash; // Convert to 32-bit integer
    }

    return Math.abs(hash).toString(36);
  }

  // Get current device fingerprint
  async getFingerprint() {
    if (!this.isInitialized) {
      await this.initialize();
    }
    return this.fingerprint;
  }

  // Store device fingerprint in localStorage
  storeDeviceFingerprint(userId, fingerprint) {
    try {
      const deviceData = {
        userId,
        fingerprint,
        timestamp: Date.now(),
        userAgent: navigator.userAgent,
        screenResolution: `${screen.width}x${screen.height}`,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };

      localStorage.setItem(
        DEVICE_FINGERPRINT_STORAGE_KEY,
        JSON.stringify(deviceData),
      );
      localStorage.removeItem(LEGACY_DEVICE_FINGERPRINT_STORAGE_KEY);
    } catch (error) {
      console.error('Failed to store device fingerprint:', error);
    }
  }

  // Get stored device fingerprint
  getStoredDeviceFingerprint() {
    try {
      const stored = localStorage.getItem(DEVICE_FINGERPRINT_STORAGE_KEY);
      if (stored) {
        return JSON.parse(stored);
      }

      const legacyStored = localStorage.getItem(
        LEGACY_DEVICE_FINGERPRINT_STORAGE_KEY,
      );
      if (!legacyStored) {
        return null;
      }

      const parsedLegacyStored = JSON.parse(legacyStored);
      localStorage.setItem(
        DEVICE_FINGERPRINT_STORAGE_KEY,
        JSON.stringify(parsedLegacyStored),
      );
      localStorage.removeItem(LEGACY_DEVICE_FINGERPRINT_STORAGE_KEY);
      return parsedLegacyStored;
    } catch (error) {
      console.error('Failed to get stored device fingerprint:', error);
      return null;
    }
  }

  // Check if current device is recognized for a user
  async isDeviceRecognized(userId) {
    try {
      const stored = this.getStoredDeviceFingerprint();
      if (!stored || stored.userId !== userId) {
        return false;
      }

      const currentFingerprint = await this.getFingerprint();
      const isRecognized = stored.fingerprint === currentFingerprint;

      return isRecognized;
    } catch (error) {
      console.error('Failed to check device recognition:', error);
      return false;
    }
  }

  // Clear stored device fingerprint
  clearStoredDeviceFingerprint() {
    try {
      localStorage.removeItem(DEVICE_FINGERPRINT_STORAGE_KEY);
      localStorage.removeItem(LEGACY_DEVICE_FINGERPRINT_STORAGE_KEY);
    } catch (error) {
      console.error('Failed to clear device fingerprint:', error);
    }
  }

  // Get device information for display
  getDeviceInfo() {
    const stored = this.getStoredDeviceFingerprint();
    if (!stored) return null;

    return {
      userAgent: stored.userAgent,
      screenResolution: stored.screenResolution,
      timezone: stored.timezone,
      lastUsed: new Date(stored.timestamp).toLocaleDateString(),
    };
  }
}

// Export singleton instance
export const deviceFingerprintService = new DeviceFingerprintService();

// Legacy function for backward compatibility
export async function getDeviceFingerprint() {
  return await deviceFingerprintService.getFingerprint();
}
